import Enums from "@/enums/enums";
import * as api from "@/service/ApiSevice";
import store from "../baseController";
export const actions = {
  DoGetPrivateFile({ commit }, input) {
    store.dispatch("IsLoading", true);
    commit("MutationPrivateFileLoadingStatus", Enums.LoadingStatusType.Loading);
    api.PrivateFileService.DoGenerateSASToken(input).then((res) => {
      let peakBlobStorage = process.env.VUE_APP_PeakBlobStorage;
      let paymentFileBlobContainer = input.fileBlobContainer;
      if (res.data.length > 0) {
        commit("MutationPrivateFileLoadingStatus", Enums.LoadingStatusType.Success);
        store.dispatch("IsLoading", false);

        const privateFile = res.data[0];
        const privateFileUrl = peakBlobStorage.UrlCombine(
          `${paymentFileBlobContainer}/${privateFile.blobPath}?${privateFile.blobSASToken}`
        );
        window.open(privateFileUrl, "_private_file");
      } else {
        commit("MutationPrivateFileLoadingStatus", Enums.LoadingStatusType.Failed);
        store.dispatch("IsLoading", false);
      }
    });
  },
};
